<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong id="pageTitle">MBP-2  Register of Loans, guarantee, Security and acquisition made by the company</strong>
        </span>
        <span style="float: right">
            <!-- <a routerLink="/mbp2List"> -->
                <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
                    <i class=" fa fa-chevron-circle-left"></i>
                    Back
                </button>
            <!-- </a> -->
        </span>
        <!-- <span style="float:right">
                <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="restrictTabflag">
                  <span>
                    <i class="fa fa-save"></i>Generate Output </span>
                </button>
        </span> -->
       
    </div>
    <div class="card-block">
        <form [formGroup]='mbpForm'>
            <div class="row">
                <div class="form-group col-md-4 col-sm-6 col-xs-12 ">
                    <br><br><label>Nature of transaction</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <select class="form-control" style="padding:6px;"
                        [formControl]="mbpForm.controls['natureOfTransaction']">
                        <option value="">Select Transaction Type</option>
                        <option name="Loan" value="loan">Loan</option>
                        <option value="G/s">Guarantee / Security</option>
                        <option value="investment">Investment / Acquisition</option>
                    </select>
                    <div *ngIf="mbpForm.controls['natureOfTransaction'].hasError('required') && mbpForm.controls['natureOfTransaction'].touched"
                        class="form-control-error-custom">
                        Nature of transaction is required
                    </div>
                    <div *ngIf="mbpForm.controls['natureOfTransaction'].hasError('pattern')||mbpForm.controls['natureOfTransaction'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Nature of transaction is invalid
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12 ">
                    <br><label>Date of making loan / investment / acquisition / giving guarantee / providing security</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                        <div class="input-group" (click)="$event.stopPropagation()">
                            <input class="form-control" [formControl]="mbpForm.controls['dateOfMakingLoan']"
                                [(ngModel)]="dateOfMakingLoanModel" style="padding:6px;z-index: 0;"
                                placeholder="dd-mm-yyyy" name="acquisitiondate" ngbDatepicker #a="ngbDatepicker"
                                (click)="a.toggle();d.close();e.close();h.close();k.close();">
                            <button class="input-group-addon"
                                (click)="a.toggle();d.close();e.close();h.close();k.close();" type="button">
                                <span class="fa fa-calendar"
                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Name of the person / body corporate to whom loan / security / investment / guarantee is made
                        or whose securities have been acquired </label>
                    <input type="text" class="form-control" maxlength="50"
                        [formControl]="mbpForm.controls.nameOfPerson">
                    <div *ngIf="mbpForm.controls['nameOfPerson'].hasError('pattern')||mbpForm.controls['nameOfPerson'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Name of the person is invalid
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Address of the person / body corporate to whom loan / security / investment / guarantee is
                        made or whose securities have been acquired </label>
                    <textarea class="form-control" maxlength="250"
                        [formControl]="mbpForm.controls.addressOfPerson"></textarea>
                    <div *ngIf="mbpForm.controls['addressOfPerson'].hasError('pattern')||mbpForm.controls['addressOfPerson'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Address of the person is invalid
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <br><label> Amount of Loan / Investment / Guarantee / Security / Acquisition
                        <span _ngcontent-c2="" style="color: red;">*</span>
                    </label>

                    <input type="text" class="form-control" maxlength="200" [formControl]="mbpForm.controls['amount']">
                    <div *ngIf="mbpForm.controls['amount'].hasError('pattern')||mbpForm.controls['amount'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Amount is invalid
                    </div>
                    <div *ngIf="mbpForm.controls['amount'].hasError('required') && mbpForm.controls['amount'].touched"
                        class="form-control-error-custom">
                        Amount is required
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12 ">
                    <br><br> <label>Time period for which it is made / given from</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                        <div class="input-group" (click)="$event.stopPropagation()">
                            <input class="form-control" [formControl]="mbpForm.controls['timePeriodFrom']"
                                [(ngModel)]="timePeriodFromModel" style="padding:6px;z-index: 0;"
                                placeholder="dd-mm-yyyy" name="acquisitiondate" ngbDatepicker #h="ngbDatepicker"
                                (click)="h.toggle();a.close();d.close();e.close();k.close();">
                            <button class="input-group-addon"
                                (click)="h.toggle();a.close();d.close();e.close();k.close();" type="button">
                                <span class="fa fa-calendar"
                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-4 col-sm-6 col-xs-12 ">
                    <label>Time period for which it is made / given to</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                        <div class="input-group" (click)="$event.stopPropagation()">
                            <input class="form-control" [formControl]="mbpForm.controls['timePeriodTo']"
                                [(ngModel)]="timePeriodToModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                name="acquisitiondate" ngbDatepicker #k="ngbDatepicker"
                                (click)="k.toggle();a.close();d.close();e.close();h.close();h.close();">
                            <button class="input-group-addon"
                                (click)="k.toggle();a.close();d.close();e.close();h.close();" type="button">
                                <span class="fa fa-calendar"
                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12 "
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'loan'">
                    <label>Rate of Interest</label>
                    <input type="text" class="form-control" [formControl]="mbpForm.controls.rateOfInterest">
                    <div *ngIf="mbpForm.controls['rateOfInterest'].hasError('pattern')||mbpForm.controls['rateOfInterest'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Rate of Interest is invalid
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'loan'">
                    <label>Date of Maturity</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [maxDate]="TodayDate"
                            [formControl]="mbpForm.controls['dateOfMaturity']" [(ngModel)]="dateofmaturityModel"
                            style="padding:6px;z-index:0;" placeholder="dd-mm-yyyy" name="dateOfMaturity" ngbDatepicker
                            #b="ngbDatepicker" (click)="b.toggle();a.close();d.close();e.close();h.close();k.close();">
                        <button class="input-group-addon"
                            (click)="b.toggle();a.close();d.close();e.close();h.close();k.close();" type="button">
                            <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'loan'">
                    <br> <label>Date of Repayment</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [maxDate]="TodayDate"
                            [formControl]="mbpForm.controls['dateOfRepayment']" [(ngModel)]="dateofrepaymentModel"
                            style="padding:6px;z-index:0;" placeholder="dd-mm-yyyy" name="dateOfRepayment" ngbDatepicker
                            #c="ngbDatepicker" (click)="c.toggle();a.close();d.close();e.close();h.close();k.close();">
                        <button class="input-group-addon"
                            (click)="c.toggle();a.close();d.close();e.close();h.close();k.close();" type="button">
                            <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12 ">
                    <label>Purpose of Loan / Investment / guarantee / Security / Acquisition</label>
                    <textarea class="form-control" [formControl]="mbpForm.controls.purposeOfLIGSA"></textarea>
                    <div *ngIf="mbpForm.controls['purposeOfLIGSA'].hasError('pattern')||mbpForm.controls['purposeOfLIGSA'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Purpose of Loan is invalid
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <br><label>Percentage of Loan / guarantee / Security / Acquisition</label>
                    <input type="percentage" class="form-control" [formControl]="mbpForm.controls.percentageOfLGSA">
                    <div *ngIf="mbpForm.controls['percentageOfLGSA'].hasError('pattern')||mbpForm.controls['percentageOfLGSA'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Percentage of Loan is invalid
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of passing Board resolution</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [maxDate]="TodayDate"
                            [formControl]="mbpForm.controls['dateOfPassingBoardResolution']"
                            [(ngModel)]="dateofpassingboardresolutionModel" style="padding:6px;z-index:0;"
                            placeholder="dd-mm-yyyy" name="dateOfPassingBoardResolution" ngbDatepicker
                            #d="ngbDatepicker" (click)="d.toggle(); a.close();e.close();h.close();k.close();">
                        <button class="input-group-addon" (click)="d.toggle();a.close();e.close();h.close();k.close();"
                            type="button">
                            <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12 ">
                    <label>Date of passing special resolution, if required</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [maxDate]="TodayDate"
                            [formControl]="mbpForm.controls['dateOfPassingResolutionIfRequired']"
                            [(ngModel)]="dateOfPassingResolutionModel" style="padding:6px;z-index:0;"
                            placeholder="dd-mm-yyyy" name="dateOfPassingResolutionIfRequired" ngbDatepicker
                            #e="ngbDatepicker" (click)="e.toggle(); a.close();d.close();h.close();k.close();">
                        <button class="input-group-addon" (click)="e.toggle();a.close();d.close();h.close();k.close();"
                            type="button">
                            <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'investment'">
                    <label>Number of securities</label>
                    <input type="text" class="form-control" [formControl]="mbpForm.controls.numberOfSecurities">
                    <div *ngIf="mbpForm.controls['numberOfSecurities'].hasError('pattern')||mbpForm.controls['numberOfSecurities'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Number of securities is invalid
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'investment'">
                    <label>Kind of securities</label>
                    <input type="text" class="form-control" [formControl]="mbpForm.controls.kindOfSecurities">
                    <div *ngIf="mbpForm.controls['kindOfSecurities'].hasError('pattern')||mbpForm.controls['kindOfSecurities'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Kind of securities is invalid
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'investment'">
                    <label>Nominal value</label>
                    <input type="text" class="form-control" [formControl]="mbpForm.controls.nominalValue">
                    <div *ngIf="mbpForm.controls['nominalValue'].hasError('pattern') && mbpForm.controls['nominalValue'].touched"
                        class="form-control-error-custom">
                        Nominal value is invalid
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'investment'">
                    <label>Paid up value</label>
                    <input type="text" class="form-control" [formControl]="mbpForm.controls.paidUpValue">
                    <div *ngIf="mbpForm.controls['paidUpValue'].hasError('pattern') && mbpForm.controls['paidUpValue'].touched"
                        class="form-control-error-custom">
                        Paid up value is invalid
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'investment'">
                    <label>Class of securities</label>
                    <input type="text" class="form-control" [formControl]="mbpForm.controls.classOfSecurities">
                    <div *ngIf="mbpForm.controls['classOfSecurities'].hasError('pattern')||mbpForm.controls['classOfSecurities'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Class of securities is invalid
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'investment'">
                    <label>Cost of acquisition (in case of securities how the purchased price was arrived at)</label>
                    <input type="text" class="form-control" [formControl]="mbpForm.controls.costAcquistion">
                    <div *ngIf="mbpForm.controls['costAcquistion'].hasError('pattern')||mbpForm.controls['costAcquistion'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Cost of acquisition is invalid
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'investment'">
                    <label>Date of selling of investment</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [maxDate]="TodayDate"
                            [formControl]="mbpForm.controls['dateOfSellingOfInvestment']"
                            [(ngModel)]="dateOfSellingOfInvestmentModel" style="padding:6px;z-index:0;"
                            placeholder="dd-mm-yyyy" name="dateOfSellingOfInvestment" ngbDatepicker #f="ngbDatepicker"
                            (click)="f.toggle();a.close();d.close();e.close();h.close();k.close();">
                        <button class="input-group-addon"
                            (click)="f.toggle();a.close();d.close();e.close();h.close();k.close();" type="button">
                            <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'investment'">
                    <label>Selling price (how the price was arrived at)</label>
                    <input type="text" class="form-control" [formControl]="mbpForm.controls.sellingPrice">
                    <div *ngIf="mbpForm.controls['sellingPrice'].hasError('pattern')||mbpForm.controls['sellingPrice'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Selling price is invalid
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'investment'">
                    <label>Balance securities left, if any</label>
                    <input type="text" class="form-control" [formControl]="mbpForm.controls.balanceSecurities">
                    <div *ngIf="mbpForm.controls['balanceSecurities'].hasError('pattern')||mbpForm.controls['balanceSecurities'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Balance securities left is invalid
                    </div>
                </div>
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'investment'">
                    <label>Client ID/DP No</label>
                    <input type="text" class="form-control" [formControl]="mbpForm.controls.clientIdDPno">
                    <div *ngIf="mbpForm.controls['clientIdDPno'].hasError('pattern')||mbpForm.controls['clientIdDPno'].hasError('maxlength') "
                        class="form-control-error-custom">
                        Client ID/DP No is invalid
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                    *ngIf="mbpForm.controls.natureOfTransaction.value == 'investment'">
                    <label>Date of Disposal</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [maxDate]="TodayDate"
                            [formControl]="mbpForm.controls['dateOfDisposal']" [(ngModel)]="dateofdisposalModel"
                            style="padding:6px;z-index:0;" placeholder="dd-mm-yyyy" name="dateOfDisposal" ngbDatepicker
                            #g="ngbDatepicker" (click)="g.toggle(); a.close();d.close();e.close();h.close();k.close();">
                        <button class="input-group-addon"
                            (click)="g.toggle();a.close();d.close();e.close();h.close();k.close();" type="button">
                            <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                    </div>
                </div>
            </div>

        </form>
    </div>
    <div class="card-footer">
        <div class="form-group" align="right" *ngIf="!restrictTabflag">
            <button class="btn btn-sm btn-primary" (click)="saveMbp('save')" type="button"
                [disabled]="!(mbpForm.valid) || disabledOnClick">
                <span><i class="fa fa-save"></i>&nbsp;Save </span>
            </button>
        </div>
        <div class="form-group" align="right" *ngIf="restrictTabflag">
            <button class="btn btn-sm btn-primary" (click)="saveMbp('update')" type="button"
                [disabled]="!(mbpForm.valid) || disabledOnClick">
                <span><i class="fa fa-save"></i>&nbsp;Update </span>
            </button>
        </div>
    </div>
</section>
<app-alert></app-alert>